import * as yup from 'yup';
import { test5erSteps } from '@/features/Sparten/pkv/schema/schema';
import {
  hasKrankentagegeldSelected,
  isArbeitnehmer,
  isBeamter,
  isStudent,
} from '@/features/Sparten/pkv/formConfigs/sharedRenderConditions';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';

const DEFAULT_VAL = '';
export const krankentageFelder = Array.from(Array(3).keys()).reduce(
  (acc, _, index) => ({
    ...acc,
    [`betrag${index}`]: yup
      .number()
      .max(500)
      .nullable()
      .default(null)
      .test('stepTests', 'Eingabe nur in Fünferschritten', (val) =>
        test5erSteps(val),
      )
      .when({
        is: () => {
          if (isBeamter() || isStudent()) {
            return false;
          }

          return index === 0 && hasKrankentagegeldSelected();
        },
        then: yup.number().required(),
      })
      .when([`tag${index}`], {
        is: (krankentagegeldTag: string | undefined) => {
          if (
            krankentagegeldTag === undefined ||
            krankentagegeldTag === DEFAULT_VAL ||
            !hasKrankentagegeldSelected()
          ) {
            return false;
          }

          if (isArbeitnehmer()) {
            return !getSimpleChoiceMeta(
              SIMPLE_CHOICE.KRANKENTAGEGELD_ARBEITNEHMER_AB_TAG,
              SIMPLE_CHOICE_META.INVALID,
            ).includes(krankentagegeldTag);
          }

          return !getSimpleChoiceMeta(
            SIMPLE_CHOICE.PKV_KRANKENTAGEGELD_AB_TAG,
            SIMPLE_CHOICE_META.INVALID,
          ).includes(krankentagegeldTag);
        },
        then: yup.number().required(),
      }),

    [`tag${index}`]: yup
      .string()
      .default('')
      .when({
        is: () => {
          if (isBeamter() || isStudent()) {
            return false;
          }

          return index === 0 && hasKrankentagegeldSelected();
        },
        then: yup.string().required(),
      }),
  }),
  {},
);

export const krankentagegeldOptionenSchema = yup.object({
  ...krankentageFelder,

  krankentageGeldFelderAnzahl: yup.array().of(yup.number()).default([0]),
  karenzzeit: yup.boolean().default(false),
  leistungBerufsunfaehigkeit: yup.boolean().default(false),
  leistungTeilBerufsunfaehigkeit: yup.boolean().default(false),
  alkoholKlausel: yup.boolean().default(false),
});
